<script setup lang="ts">
import { computed } from 'vue'

import { Icon } from '@collector/shared-ui'
import {
  ParticipantBox,
  ParticipantLogo,
  ParticipantName,
} from '@collector/shared-ui-domain'
import { BaseballEventStatusId } from '@collector/sportsapi-client-legacy'
import { useEvent } from '@desktop/views/Relation/composables'

import {
  useBaseballParticipants,
  useEventDetailHalf,
} from '../../../../composables'
import { inningEventStatuses } from '../../../../configuration'

// composables
const { eventDetailHalfValue } = useEventDetailHalf()
const { battingParticipant: participant } = useBaseballParticipants()
const { event } = useEvent()

const inningText = computed(() => {
  const index = inningEventStatuses.indexOf(
    event.value?.status_id as BaseballEventStatusId,
  )

  if (index > -1) {
    return `${index + 1}`
  }

  return ''
})
</script>

<template>
  <ParticipantBox
    v-if="participant"
    class="flex items-center gap-x-1.5 px-1"
    :participant
  >
    <span class="min-w-2.5 pl-1 text-sm font-bold">{{ inningText }}</span>
    <Icon
      :icon="eventDetailHalfValue === 'bottom' ? 'caret-down' : 'caret-up'"
    />

    <div class="flex items-center gap-x-1.5">
      <ParticipantLogo :participant />
      <ParticipantName
        class="line-clamp-2 max-w-50 min-w-32 pr-1 text-sm font-bold"
        :participant
      />
    </div>

    <img src="./baseball-bat.svg" />
  </ParticipantBox>
</template>
